module.exports = __webpack_public_path__ + "static/media/icon_summary.5488a313.svg";